import { render, staticRenderFns } from "./MagArticleTools.vue?vue&type=template&id=5bde347a&scoped=true"
import script from "./MagArticleTools.vue?vue&type=script&lang=js"
export * from "./MagArticleTools.vue?vue&type=script&lang=js"
import style0 from "./MagArticleTools.vue?vue&type=style&index=0&id=5bde347a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde347a",
  null
  
)

export default component.exports